const OCCRewardSmallIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1667 2.83333H16.8333V0.5H5.16667V2.83333H2.83333C1.55 2.83333 0.5 3.88333 0.5 5.16667V6.33333C0.5 9.30833 2.74 11.735 5.62167 12.0967C6.35667 13.8467 7.93167 15.165 9.83333 15.55V19.1667H5.16667V21.5H16.8333V19.1667H12.1667V15.55C14.0683 15.165 15.6433 13.8467 16.3783 12.0967C19.26 11.735 21.5 9.30833 21.5 6.33333V5.16667C21.5 3.88333 20.45 2.83333 19.1667 2.83333ZM2.83333 6.33333V5.16667H5.16667V9.62333C3.81333 9.13333 2.83333 7.85 2.83333 6.33333ZM11 13.3333C9.075 13.3333 7.5 11.7583 7.5 9.83333V2.83333H14.5V9.83333C14.5 11.7583 12.925 13.3333 11 13.3333ZM19.1667 6.33333C19.1667 7.85 18.1867 9.13333 16.8333 9.62333V5.16667H19.1667V6.33333Z"
        fill="#ffcf23"
      />
    </svg>
  );
};

export default OCCRewardSmallIcon;
